const signInErrorCodes = {
  "auth/invalid-email": "El email no es válido",
  "auth/user-disabled": "La cuenta de usuario ha sido deshabilitada",
  "auth/user-not-found": "Usuario no encontrado",
  "auth/wrong-password": "Contraseña incorrecta",
  unknownError: "Se ha producido un error"
};

const USER_LOGIN = "extragestor/login/USER_LOGIN";
const USER_LOGGED = "extragestor/login/USER_LOGGED";
const USER_LOGOUT = "extragestor/login/USER_LOGOUT";
const ERROR = "extragestor/login/ERROR";
const USER_IS_ADMIN = "extragestor/login/USER_IS_ADMIN";
const USER_IS_NORMAL = "extragestor/login/USER_IS_NORMAL";
const RESET_USER_TYPE = "extragestor/login/RESET_USER_TYPE";
const RESET_ERROR = "extragestor/login/RESET_ERROR";

/*---*/
export {
  signInErrorCodes,
  USER_LOGIN,
  USER_LOGGED,
  USER_LOGOUT,
  ERROR,
  USER_IS_ADMIN,
  USER_IS_NORMAL,
  RESET_USER_TYPE,
  RESET_ERROR
};



// WEBPACK FOOTER //
// ./src/ducks/login/types.js